import { render, staticRenderFns } from "./user-setup.component.vue?vue&type=template&id=4354d398"
import script from "./user-setup.component.ts?vue&type=script&lang=ts&external"
export * from "./user-setup.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4354d398')) {
      api.createRecord('4354d398', component.options)
    } else {
      api.reload('4354d398', component.options)
    }
    module.hot.accept("./user-setup.component.vue?vue&type=template&id=4354d398", function () {
      api.rerender('4354d398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user-setup/user-setup.component.vue"
export default component.exports